/* Behaviour for snippets/ASRJ-add-charm.liquid. Product title is read from #CharmDrawer[data-product-title]. */
document.addEventListener('DOMContentLoaded', function() {
    const drawer = document.getElementById('CharmDrawer');
    const overlay = document.getElementById('CharmDrawerOverlay');
    const closeBtn = drawer.querySelector('.charm-isolated-close');
    const checkboxes = document.querySelectorAll('.charm-checkbox');
    const mainPageTrigger = document.getElementById('OpenCharmDrawerBtn');
    const offerBanner = document.getElementById('CharmOfferBanner');
    
    // Footer Elements
    const saveBtn = document.getElementById('SaveCharmsBtn');
    const saveBtnText = document.getElementById('SaveCharmsBtnText');
    
    // Use json filter to safely parse titles containing quotes (e.g., Jessie's Purse)
    const productTitle = drawer.getAttribute('data-product-title') || '';
    
    window.selectedCharmsToAttach = [];

    function updateCharmsState() {
      let selectedPrices = [];
      window.selectedCharmsToAttach = [];
      
      checkboxes.forEach(cb => {
        if (cb.checked) {
          selectedPrices.push(parseInt(cb.dataset.price));
          window.selectedCharmsToAttach.push(cb.dataset.id);
        }
      });
      
      const count = window.selectedCharmsToAttach.length;

      // Update Offer Banner
      if (offerBanner) {
        offerBanner.classList.remove('is-2-charms', 'is-3-charms');
        if (count === 2) {
          offerBanner.classList.add('is-2-charms');
        } else if (count >= 3) {
          offerBanner.classList.add('is-3-charms');
        }
      }
      
      // Update the Footer Button Text
      if (saveBtnText) {
        const charmWord = count === 1 ? 'charm' : 'charms';
        saveBtnText.innerText = `${count} ${charmWord} added to ${productTitle}`;
      }
      
      // Update Floating Trigger Button
      if (mainPageTrigger) {
        if (count > 0) {
          mainPageTrigger.innerHTML = count === 1 ? '1 charm added' : `${count} charms added`;
          mainPageTrigger.classList.remove('charm-default-state');
          mainPageTrigger.classList.add('charm-active-state');
          
          mainPageTrigger.style.setProperty('background', '#111', 'important');
          mainPageTrigger.style.setProperty('color', 'var(--bg)', 'important');
          mainPageTrigger.style.setProperty('border', '1px solid #111', 'important');
          mainPageTrigger.style.setProperty('padding', '10px 18px', 'important');
        } else {
          mainPageTrigger.innerHTML = '<span style="font-size: 1.3em; margin-right: 4px; vertical-align: middle; line-height: 1;">+</span><span style="vertical-align: middle;">add charms</span>';
          mainPageTrigger.classList.add('charm-default-state');
          mainPageTrigger.classList.remove('charm-active-state');
          
          mainPageTrigger.style.removeProperty('background');
          mainPageTrigger.style.removeProperty('color');
          mainPageTrigger.style.removeProperty('border');
          mainPageTrigger.style.removeProperty('padding');
        }
      }
    }

    // Function to re-order items (selected to the top)
    function sortCharms() {
      const container = document.querySelector('.charm-isolated-products-container');
      if (!container) return;
      
      const items = Array.from(container.querySelectorAll('.charm-isolated-item'));
      items.sort((a, b) => {
        const aChecked = a.querySelector('.charm-checkbox').checked;
        const bChecked = b.querySelector('.charm-checkbox').checked;
        if (aChecked && !bChecked) return -1;
        if (!aChecked && bChecked) return 1;
        return 0;
      });
      
      // Re-appending naturally re-orders them in the DOM
      items.forEach(item => container.appendChild(item));
    }

    updateCharmsState();
    checkboxes.forEach(cb => cb.addEventListener('change', updateCharmsState));

    // Open/Toggle logic
    window.openCharmDrawer = function() {
      // Toggle if already open (acts as a close when clicking '+ add charm' again)
      if (drawer.classList.contains('is-active')) {
        closeDrawer();
        return;
      }
      
      // Bubble selected charms to top before opening
      sortCharms();
      
      // Reset scroll position to top so selected items are immediately visible
      const scrollableContent = drawer.querySelector('.charm-isolated-content');
      if (scrollableContent) {
        scrollableContent.scrollTop = 0;
      }
      
      drawer.classList.add('is-active');
      // Only show overlay and lock scrolling on mobile screens
      if (window.innerWidth < 480) {
        overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden'; 
      }
    };

    // Close logic
    function closeDrawer() {
      drawer.classList.remove('is-active');
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    function resetCharmsState() {
      checkboxes.forEach(cb => cb.checked = false);
      updateCharmsState(); 
    }

    // Event Listeners for Closing
    closeBtn.addEventListener('click', closeDrawer);
    saveBtn.addEventListener('click', closeDrawer);
    
    // Close on mobile overlay click
    overlay.addEventListener('click', function() {
      if (window.innerWidth < 480) closeDrawer();
    });

    // Close with ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-active')) {
        closeDrawer();
      }
    });

    // Close on outside click for desktop (without blocking scroll capabilities)
    document.addEventListener('click', function(e) {
      if (window.innerWidth >= 480 && drawer.classList.contains('is-active')) {
        const isClickInsideDrawer = drawer.contains(e.target);
        // Exclude the trigger button, so the toggle logic handles it
        const isClickOnTrigger = mainPageTrigger && mainPageTrigger.contains(e.target);
        
        if (!isClickInsideDrawer && !isClickOnTrigger) {
          closeDrawer();
        }
      }
    });

    // ADD TO CART INTERCEPTION LOGIC
    document.addEventListener('click', function(e) {
      const addToCartBtn = e.target.closest('button[name="add"], .add-to-cart, #AddToCart, .product-form__submit, [data-add-to-cart]');
      
      if (addToCartBtn && window.selectedCharmsToAttach && window.selectedCharmsToAttach.length > 0) {
        const form = addToCartBtn.closest('form[action*="/cart/add"]');
        
        if (form) {
          e.preventDefault();
          e.stopImmediatePropagation(); 
          
          addToCartBtn.classList.add('is-loading');
          addToCartBtn.setAttribute('aria-busy', 'true');
          
          let charmsToPush = [];
          
          window.selectedCharmsToAttach.forEach(charmId => {
            charmsToPush.push({
              id: charmId,
              quantity: 1,
              properties: { '_Added via': 'Add charm' }
            });
          });

          const clearLoading = () => {
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.setAttribute('aria-busy', 'false');
          };

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: charmsToPush })
          })
          .then(res => res.json())
          .then(data => {
             resetCharmsState();
             // The theme's own add flow toggles .loading/[disabled] on the button but never clears .is-loading.
             const observer = new MutationObserver(() => {
               if (!addToCartBtn.classList.contains('loading')) {
                 observer.disconnect();
                 clearTimeout(fallback);
                 clearLoading();
               }
             });
             const fallback = setTimeout(() => { observer.disconnect(); clearLoading(); }, 8000);
             addToCartBtn.click();
             observer.observe(addToCartBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });
          })
          .catch(error => {
             console.error('Error adding bundled items:', error);
             clearLoading();
          });
        }
      }
    }, true); 
  });
